import React from 'react';

export const Ticket = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width || '20'}
    height={height || '20'}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.8229 3.02815C10.0844 2.91988 10.3931 2.83838 10.6873 2.83838H16.1641C16.5103 2.83976 16.8419 2.97788 17.0866 3.22266C17.3314 3.46743 17.4695 3.79901 17.4709 4.14518L17.4709 4.14767L17.4709 9.62196C17.4709 9.91586 17.3898 10.2243 17.2816 10.4859C17.1733 10.7475 17.0126 11.0234 16.8043 11.2317L10.0171 18.019L10.0161 18.02C9.77036 18.2645 9.43781 18.4018 9.09114 18.4018C8.74447 18.4018 8.41192 18.2645 8.16621 18.02L8.16518 18.019L2.28932 12.1431C2.04477 11.8974 1.90747 11.5648 1.90747 11.2182C1.90747 10.8715 2.04477 10.5389 2.28932 10.2932L9.07756 3.505C9.28552 3.29704 9.56147 3.13641 9.8229 3.02815ZM10.3012 4.18304C10.139 4.25019 10.019 4.33134 9.96144 4.38888L3.17527 11.1751C3.1752 11.1751 3.17533 11.175 3.17527 11.1751C3.16399 11.1865 3.15747 11.2021 3.15747 11.2182C3.15747 11.2342 3.1638 11.2496 3.17507 11.2611C3.17514 11.2611 3.17501 11.261 3.17507 11.2611L9.04803 17.134C9.04812 17.1341 9.04794 17.134 9.04803 17.134C9.05945 17.1453 9.0751 17.1518 9.09114 17.1518C9.10715 17.1518 9.12252 17.1455 9.13394 17.1343C9.13405 17.1342 9.13384 17.1344 9.13394 17.1343L15.9204 10.3479C15.9785 10.2898 16.0596 10.1697 16.1265 10.008C16.1935 9.84624 16.2209 9.70395 16.2209 9.62196V4.14959C16.2207 4.13343 16.2142 4.11798 16.2028 4.10654C16.1913 4.0951 16.1759 4.08859 16.1597 4.08838H10.6873C10.6057 4.08838 10.4633 4.11591 10.3012 4.18304Z"
      fill={color || '#4C43AA'}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.475 9.0617C13.1516 9.0617 13.7 8.51324 13.7 7.8367C13.7 7.16015 13.1516 6.61169 12.475 6.61169C11.7985 6.61169 11.25 7.16015 11.25 7.8367C11.25 8.51324 11.7985 9.0617 12.475 9.0617ZM12.475 10.3117C13.8419 10.3117 14.95 9.2036 14.95 7.8367C14.95 6.46979 13.8419 5.36169 12.475 5.36169C11.1081 5.36169 10 6.46979 10 7.8367C10 9.2036 11.1081 10.3117 12.475 10.3117Z"
      fill={color || '#4C43AA'}
    />
  </svg>
);
